import { render, staticRenderFns } from "./inf_scroll.vue?vue&type=template&id=4c76629e"
import script from "./inf_scroll.vue?vue&type=script&lang=js"
export * from "./inf_scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports